import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, AlertTriangle } from 'lucide-react';
import { HSLogo } from '@/components/HSLogo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MagicLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/auth/magic?token=${token}`);
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        setStatus('success');
        setTimeout(() => { window.location.href = '/dashboard'; }, 1000);
      } catch (err) {
        setStatus(err.response?.data?.detail || 'Invalid or expired link');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <HSLogo size={48} className="mx-auto mb-4" />
        {status === 'loading' && <><Loader2 className="w-8 h-8 animate-spin text-emerald-500 mx-auto mb-3" /><p className="text-muted-foreground">Logging you in...</p></>}
        {status === 'success' && <><p className="text-emerald-400 font-bold text-lg mb-1">Welcome to HumanScaled</p><p className="text-muted-foreground text-sm">Redirecting to dashboard...</p></>}
        {status !== 'loading' && status !== 'success' && <><AlertTriangle className="w-8 h-8 text-red-400 mx-auto mb-3" /><p className="text-red-400 font-bold mb-1">Login Failed</p><p className="text-muted-foreground text-sm">{status}</p></>}
      </div>
    </div>
  );
};

export default MagicLogin;
